import { Grid, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";

import StepperItem from "../../../../Components/CustomerStepper/StepperItem";
import { ValidatedTextFieldProps } from "../../../../Components/Helpers/ValidatedTextField";
import {
  distanceToCenterValidation,
  firstNameValidation,
  lastNameValidation
} from "../../../../Utils/ValidationSchema";
import UserSessionContextCenterSelector from "../../../Ribbon/Compositions/SessionContextCenterSelector";

interface IIntroStepProps {
  GreetingComponent: React.FC;
  ConfirmationComponent: React.FC;
  FirstNameField: React.FC<Omit<ValidatedTextFieldProps, "onChange" | "value">>;
  LastNameField: React.FC<Omit<ValidatedTextFieldProps, "onChange" | "value">>;
  PhoneNumberField: React.FC;
  ZipCodeField: React.FC<Omit<ValidatedTextFieldProps, "onChange" | "value">>;
  DistanceField: React.FC<Omit<ValidatedTextFieldProps, "onChange" | "value">>;
  PortalButton: React.FC;
}

/** Styled Intro Step with child components. */
const IntroStep: React.FC<IIntroStepProps> = ({
  GreetingComponent,
  ConfirmationComponent,
  FirstNameField,
  LastNameField,
  PhoneNumberField,
  ZipCodeField,
  DistanceField,
  PortalButton
}) => {
  return (
    <Stack spacing={1}>
      <StepperItem>
        <Typography variant="stageDirection">
          If caller refuses information, use
          <strong> Rebuttals </strong>
          to overcome objections or answer questions.
        </Typography>
      </StepperItem>
      <StepperItem>
        <GreetingComponent />
      </StepperItem>
      <StepperItem>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="body2">Caller&apos;s Name:</Typography>
          </Grid>
          <Grid container item spacing={1}>
            <Grid item>
              <FirstNameField label="First Name" {...firstNameValidation} />
            </Grid>
            <Grid item>
              <LastNameField label="Last Name" {...lastNameValidation} />
            </Grid>
          </Grid>
        </Grid>
      </StepperItem>
      <StepperItem>
        <PhoneNumberField />
      </StepperItem>
      <StepperItem>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <Typography variant="body2">Validate Zip Code:</Typography>
          </Grid>
          <Grid container item spacing={1} wrap="nowrap">
            <Grid item>
              <ZipCodeField debounce={1000} label="Zip Code" sx={{ maxWidth: "8rem" }} />
            </Grid>
            <Grid item>
              <DistanceField
                label="Distance To"
                debounce={0}
                sx={{ maxWidth: "12.3rem" }}
                {...distanceToCenterValidation}
              />
            </Grid>
            <Grid item xs md={5}>
              <UserSessionContextCenterSelector />
            </Grid>
            <Grid item>
              <PortalButton />
            </Grid>
          </Grid>
        </Grid>
      </StepperItem>
      <StepperItem>
        <ConfirmationComponent />
      </StepperItem>
      <StepperItem>
        <Typography variant="body2">
          <strong>Thank you!</strong>
        </Typography>
      </StepperItem>
    </Stack>
  );
};

export default IntroStep;
